import {
	auditService,
	GET_CASE_STEPS_STATUS,
	GET_LAWYER_CASE_DETAILS,
} from '@/api';
import { useQueryClient } from '@tanstack/react-query';
import { useNotification } from './useNotification';
import { getValidCaseId } from '@/utils';

interface Props {
	id: string;
}

export const useCaseAdministration = ({ id }: Props) => {
	const { toastSuccess, toastError } = useNotification();
	const queryClient = useQueryClient();
	const caseId = getValidCaseId(id);

	const handleMoveToTheNextPhase = async () => {
		try {
			if (caseId) {
				await auditService.patchMoveToTheNextPhase(caseId);
				queryClient.refetchQueries({
					queryKey: [GET_CASE_STEPS_STATUS, caseId],
				});
				queryClient.refetchQueries({
					queryKey: [GET_LAWYER_CASE_DETAILS, caseId],
				});
				toastSuccess('You have successfully advanced to the next phase.');
			}
		} catch (error) {
			toastError(
				'An error occurred while advancing to the next phase. Please try again.'
			);
		}
	};

	return {
		handleMoveToTheNextPhase,
	};
};
